(() => {
  if (customElements.get('product-quickshop')) {
    return;
  }

  class ProductQuickshop extends HTMLElement {
    constructor() {
      super();

      this.onResize = this.onResize.bind(this);
      this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.closeButton?.addEventListener('click', this.onCloseButtonClick);

      this.debouncedResize = debounce(this.onResize, 300);

      window.addEventListener('resize', this.debouncedResize);
    }

    detachEvents() {
      this.closeButton?.removeEventListener('click', this.onCloseButtonClick);

      window.removeEventListener('resize', this.debouncedResize);
    }

    init() {
      this.productsContainer = this.closest('[data-products-container]');
      this.closeButton = this.querySelector('[data-close-button]');
      const productCardRow = this.getProductCardRow();

      this.updateCSSVariable(productCardRow + 1);

      this.scrollToSection();
    }

    onResize() {
      const productCardRow = this.getProductCardRow();

      this.updateCSSVariable(productCardRow + 1);
    }

    getProductCardRow() {
      if (!this.productsContainer) {
        return 1;
      }

      const items = Array.from(this.productsContainer.querySelectorAll('[data-product-card]'));
      const index = items.indexOf(this.productsContainer.querySelector('[data-product-card].has-active-quickshop'));
      const computedStyle = window.getComputedStyle(this.productsContainer);
      const columns = computedStyle.gridTemplateColumns.split(' ').length;

      return Math.floor(index / columns) + 1;
    }

    updateCSSVariable(row = '99') {
      document.documentElement.style.setProperty('--product-quickshop-row', row);
    }

    scrollToSection() {
      const position = this.getBoundingClientRect().top + window.scrollY;
      const announcementHeight = parseFloat(
        getComputedStyle(document.documentElement)
        .getPropertyValue('--announcement-bar-height')
      ) || 0;
      const headerHeight = parseFloat(
        getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
      ) || 0;
      let offsetTop = position - announcementHeight;

      if (!window.matchMedia('(min-width: 990px)').matches) {
        offsetTop = position - announcementHeight - headerHeight;
      }

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    onCloseButtonClick(event) {
      event.preventDefault();

      this.remove();
    }
  }

  customElements.define('product-quickshop', ProductQuickshop);
})();


(() => {
  if (customElements.get('quickshop-trigger')) {
    return;
  }

  class QuickshopTrigger extends HTMLElement {
    static LOADED_CLASS = 'is-loaded';

    constructor() {
      super();

      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.button?.addEventListener('click', this.onButtonClick);
    }

    detachEvents() {
      this.button?.removeEventListener('click', this.onButtonClick);
    }

    init() {
      this.button = this.querySelector('[data-quickshop-trigger]');
      this.productsContainer = this.closest('[data-products-container]');
      this.featuredProductSection = this.closest('[data-featured-product]');
    }

    onButtonClick(event) {
      if (!this.productsContainer && !this.featuredProductSection) {
        return;
      }

      event.preventDefault();

      fetch(this.button.href)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html');
          const productQuickshop = html.querySelector('product-quickshop');
          const activeProductQuickshop = document.querySelector('product-quickshop');

          this.productsContainer
            ?.querySelectorAll('[data-product-card]')
            ?.forEach(productCard => productCard.classList.toggle('has-active-quickshop', productCard === this.button.closest('[data-product-card]')));

          activeProductQuickshop?.remove();

          productQuickshop.classList.add(QuickshopTrigger.LOADED_CLASS);

          if (this.featuredProductSection) {
            this.featuredProductSection.insertAdjacentElement('afterend', productQuickshop);
          }

          if (this.productsContainer) {
            this.productsContainer.prepend(productQuickshop);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('quickshop-trigger', QuickshopTrigger);
})();
